import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolesPermissionsComponent } from './roles-permissions.component';
import { ButtonModule } from 'primeng/button';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SelectModule } from 'primeng/select';
import { PanelMenuModule } from 'primeng/panelmenu';
import { TreeModule } from 'primeng/tree';
import { TableModule } from 'primeng/table';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';

import { LoadingComponent } from './loading/loading.component';
import { ToolbarModule } from 'primeng/toolbar';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { RolesPermissionsService } from './roles-permissions.service';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';

@NgModule({
  declarations: [RolesPermissionsComponent, LoadingComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CascadeSelectModule,
    TooltipModule,
    ToolbarModule,
    DropdownModule,
    OverlayPanelModule,
    RadioButtonModule,
    SelectModule,
    PanelMenuModule,
    TreeModule,
    TableModule,
    ToggleSwitchModule,
    ConfirmDialogModule,
    ToastModule,
    CheckboxModule,
    ProgressSpinnerModule,
  ],
  providers: [RolesPermissionsService, ConfirmationService, MessageService],
  exports: [RolesPermissionsComponent],
})
export class EcoMaestroRolesPermissionsModule {}
